/* ==========================================================================
   SearcherFli > Client > Classes
   ========================================================================== */

/* Modules */
const Select = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js');

/* eslint-disable */
const SelectActions = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js/store/actions');
/* eslint-enable */

const { actions } = require('../store/actions');

const configuration = require('../config');

/* Init */
function initClasses(instance) {
    const panel = instance;

    /* Selector */
    const { selector } = instance;

    /* Reference */
    panel.classes = Select(`${selector} [data-component='SelectRxjs'][data-type='${configuration().type.classes}']`);

    if (!panel.classes) return;

    /* Actions */
    panel.actions = {
        ...instance.actions,
        changeClasses: payload => {
            return instance.store.dispatch(actions.changeClasses(payload));
        }
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        changeClasses: instance.classes.store.subscribe((_, action) => {
            if (action.type !== SelectActions.types.SELECT_OPTION) return;

            /* Dispatch */
            instance.actions.changeClasses(action.payload);
        })
    };

    /* Start */
    const { value } = instance.classes.store.select('select');

    if (!value) {
        return;
    }

    /* Sync */
    instance.actions.setSearcher({ classes: value });
}

/* Destroy */
function destroyClasses(instance) {
    const panel = instance;

    /* Reference */
    instance.classes.actions.destroy();
    delete panel.classes;

    /* Actions */
    delete panel.actions.changeClasses;

    /* Reactions */
    instance.reactions.changeClasses.unsubscribe();
    delete panel.reactions.changeClasses;
}

/* Exports */
module.exports = {
    initClasses,
    destroyClasses
};
